import './Home.scss';

export const Home = () => {
    return (
        <div className={"home-page"}>
            <h1>Bienvenue sur killianfauvette.fr !</h1>
            <p>Le site est toujours en cours de construction, mais il sera bientôt disponible !</p>
        </div>
    );
};